import { ButtonAction } from '@heidi/analytics/vocabulary';
import { Button } from '@heidi/design-system/button';
import { TypographyP2Bold } from '@heidi/design-system/typography';
import { Copy, CopyCheck } from 'lucide-react';
import { FormattedMessage, useIntl } from 'react-intl';

import { getDictationAnalyticsPorts } from '../../../dictation-analytics-ports';

export interface DictationResultContentProps {
  /** Whether the text has been copied to clipboard. */
  isCopied: boolean;
  /** Called when the copy button is clicked. */
  onCopy: () => void;
}

export const DictationResultContent = ({
  isCopied,
  onCopy,
}: DictationResultContentProps) => {
  const intl = useIntl();

  const ariaLabel = isCopied
    ? intl.formatMessage({ defaultMessage: 'Copied', id: 'p556q3uvbn' })
    : intl.formatMessage({ defaultMessage: 'Copy to clipboard', id: 'aCdAsIsVv0' });

  return (
    <Button
      size="lg"
      type="button"
      variant="ghost"
      className="flex items-center gap-2 rounded-2xl border border-border bg-surface-accent/80 px-3 py-2 backdrop-blur-sm newBrandDark:bg-surface-elevated/80"
      onClick={(event) => {
        onCopy();
        getDictationAnalyticsPorts().ui.trackUnscopedButtonClicked(
          ButtonAction.DictationWidgetCopy,
          event.currentTarget.textContent ?? ''
        );
      }}
      aria-label={ariaLabel}
    >
      <TypographyP2Bold
        className={isCopied ? 'text-validation-success' : 'text-text-secondary'}
      >
        {isCopied ? (
          <FormattedMessage defaultMessage="Copied" id="p556q3uvbn" />
        ) : (
          <FormattedMessage defaultMessage="Copy to clipboard" id="aCdAsIsVv0" />
        )}
      </TypographyP2Bold>
      {isCopied ? (
        <CopyCheck className="size-4 text-validation-success" />
      ) : (
        <Copy className="size-4 text-text-secondary" />
      )}
    </Button>
  );
};
